import { render } from "./BaseCheckboxGroup.vue?vue&type=template&id=7695f64e"
import script from "./BaseCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__